












import { Component, Mixins } from "vue-property-decorator";
import { MultiOrderableSelectableMixin } from "../../system/selectors/mixins";
import MultiOrderableOptionListBoxSelector from "../../system/selectors/MultiOrderableOptionListBoxSelector.vue";
import { DocumentKindSelectableMixin } from "./mixins";

@Component({
  components: {
    MultiOrderableOptionListBoxSelector,
  },
})
export default class MultiOrderableDocumentKindListSelector extends Mixins(DocumentKindSelectableMixin, MultiOrderableSelectableMixin) {
}
